import * as React from "react";
import {
  Flex,
  Menu,
  MenuButton,
  IconButton,
  MenuList,
  MenuItem
} from "@chakra-ui/react";
import { BiEditAlt } from "react-icons/bi";
import { IoEllipsisHorizontal, IoTrashOutline } from "react-icons/io5";
import { Link } from "react-router-dom";
import { useToast } from "duck";
import Modal from "../../../modal";

interface ActionsProps {
  editURL: string;
  deleteTitle?: string;
  deleteDescription?: string;
  onDelete?(toast: (message: string) => void): Promise<any>;
  extra?: React.ReactNode;
}

const Actions: React.FC<ActionsProps> = ({
  editURL,
  deleteTitle,
  deleteDescription = "Are you sure you want to delete? You can’t undo this action afterwards.",
  onDelete,
  extra
}) => {
  const toast = useToast();

  return (
    <Flex justifyContent="center">
      <Menu strategy="fixed">
        <MenuButton
          size="xs"
          mr={0}
          variant="unstyled"
          as={IconButton}
          display="flex"
          icon={<IoEllipsisHorizontal style={{ marginRight: 0 }} />}
        />

        <MenuList>
          <MenuItem as={Link} to={editURL} icon={<BiEditAlt />}>
            Edit
          </MenuItem>

          {onDelete && deleteTitle && (
            <Modal.Confirm
              title={deleteTitle}
              body={deleteDescription}
              onConfirm={() =>
                onDelete(msg => toast({ description: msg, status: "success" }))
              }
            >
              <MenuItem icon={<IoTrashOutline />}>Delete</MenuItem>
            </Modal.Confirm>
          )}

          {extra}
        </MenuList>
      </Menu>
    </Flex>
  );
};

export default Actions;
